import { addNameWithCommaFormatter } from "components/Formatter";
import { textFormatter } from "components";
import { DateFormatess } from "helpers";
import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import ReportCategory from "pages/User/ReportCategory/index.page";
import {
  checkValidData,
  commasFormatter,
  dayJsDateFormatter
} from "utils";

function AboutSection03({
  memorialData,
  t,
  role,
  isModal,
  id,
}) {
  const [showReportModal, setReportModal] = useState(false);

  return (
    <>
      <section className="aboutSecDetail py-80" id="about">
        <Container>
          <div className="aboutSecDetail_inner position-relative">
            <div className="d-flex justify-content-between">
              <h3 className="mb-0">{t("text.theme.about")}</h3>
              <div className="aboutSecDetail_socialmedia">
                <ul className="list-unstyled mb-0 d-flex">
                  {memorialData?.instagram && (
                    <li>
                      <Link
                        target="_blank"
                        to={memorialData?.instagram}
                        className="d-flex justify-content-center align-items-center"
                        aria-label="instagram"
                      >
                        {" "}
                        <em className="icon-instagram" />{" "}
                      </Link>
                    </li>
                  )}
                  {memorialData?.twitter && (
                    <li>
                      <Link
                        target="_blank"
                        to={memorialData?.twitter}
                        className="d-flex justify-content-center align-items-center"
                        aria-label="twitter"
                      >
                        {" "}
                        <em className="icon-twitter" />{" "}
                      </Link>
                    </li>
                  )}
                  {memorialData?.facebook && (
                    <li>
                      <Link
                        target="_blank"
                        to={memorialData?.facebook}
                        className="d-flex justify-content-center align-items-center"
                        aria-label="facebook"
                      >
                        {" "}
                        <em className="icon-facebook" />{" "}
                      </Link>
                    </li>
                  )}
                  {role === "user" && !isModal && (
                    <li>
                      <Link
                        to="#"
                        className="d-flex align-items-center justify-content-center aboutSec_social_icon"
                        aria-label="report"
                        onClick={(e) => {
                          e.preventDefault();
                          setReportModal(true)
                        }}
                      >
                        <em className="icon-report" />
                      </Link>
                      {/* <Dropdown className="d-flex justify-content-center align-items-center">
                          <Dropdown.Toggle className="aboutSecDetail_social_icon p-0 border-0">
                            <em className="icon-more-vertical" />
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="border-0 p-0">
                            <Dropdown.Item href="#/action-1">
                              Report User
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown> */}
                    </li>
                  )}
                </ul>
              </div>
            </div>
            <div className="aboutSecDetail_list">
              <Row>
                <Col md={6} sm={12}>
                  <div className="aboutSecDetail_listleft">
                    <ul className="list-unstyled mb-0">
                      {memorialData?.birthState?.name && (
                        <li className="d-flex align-items-start">
                          <span>{t("text.theme.born")}</span>:{" "}
                          {dayJsDateFormatter(
                            memorialData?.birthDate,
                            DateFormatess
                          )}
                          ,{" "}
                          {checkValidData(
                            textFormatter(memorialData?.birthState?.name)
                          )}
                          ,{" "}
                          {checkValidData(
                            textFormatter(
                              memorialData?.birthCountry?.countryCode
                            )
                          )}{" "}
                        </li>
                      )}
                      {memorialData?.birthCountry?.name !== null ||
                        (memorialData?.birthState?.name !== null && (
                          <li className="d-flex align-items-start">
                            <span>{t("text.theme.birthPlace")}</span>:{" "}
                            {addNameWithCommaFormatter(
                              textFormatter(memorialData?.birthState?.name),
                              textFormatter(memorialData?.birthCountry?.name)
                            )}
                          </li>
                        ))}
                      {memorialData?.spouse && (
                        <li className="d-flex text-break align-items-start">
                          <span>Spouse</span>:{" "}
                          {memorialData?.spouse ? (
                            <>
                              {checkValidData(
                                textFormatter(memorialData?.spouse?.fullName)
                              )}{" "}
                              (m.{" "}
                              {dayJsDateFormatter(
                                memorialData?.dateOfMarriage,
                                "YYYY"
                              )}
                              )
                            </>
                          ) : (
                            " - "
                          )}
                        </li>
                      )}
                    </ul>
                  </div>
                </Col>
                <Col md={6} sm={12}>
                  <div className="aboutSecDetail_listright">
                    <ul className="list-unstyled mb-0">
                      {memorialData?.father?.fullName && (
                        <li className="d-flex text-break align-items-start">
                          <span>{t("text.theme.parents")}</span>:{" "}
                          {addNameWithCommaFormatter(
                            textFormatter(memorialData?.father?.fullName),

                            textFormatter(memorialData?.mother?.fullName)
                          )}
                        </li>
                      )}
                      {memorialData?.children?.length > 0 && (
                        <li className="d-flex text-break align-items-start">
                          <span className="flex-shrink-0">
                            {t("text.theme.children")}
                          </span>{" "}
                          :{" "}
                          {commasFormatter(
                            memorialData?.children?.map((item) =>
                              textFormatter(item?.fullName)
                            )
                          )}
                        </li>
                      )}
                      {memorialData?.siblings?.length > 0 && (
                        <li className="d-flex text-break align-items-start">
                          <span className="flex-shrink-0">
                            {t("text.theme.siblings")}
                          </span>
                          :{" "}
                          {commasFormatter(
                            memorialData?.siblings?.map((item) =>
                              textFormatter(item?.fullName)
                            )
                          )}
                        </li>
                      )}
                    </ul>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Container>
        {/* Report modal */}
        {showReportModal && (
          <ReportCategory
            setReportModal={setReportModal}
            showReportModal={showReportModal}
            id={id}
          />
        )}
      </section>
    </>
  );
}

export default AboutSection03;
